import { formatTz } from '@utils/dateUtils';

const formatDate = (dateObj: Date): string => formatTz(dateObj, 'yyyy-MM-dd');

export default formatDate;
